module.exports = __webpack_public_path__ + "static/media/Mexico.bae04c57.jpg";